var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 154 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#filter0_i_5524_7477)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6BC95B",
    d: "m87.082 21.625 66.146 66.146-66.146 66.147-10.514-10.514c5.635-13.017 3.458-28.261-6.731-38.388C59.698 94.939 44.5 92.786 31.503 98.34L20.936 87.77 32.03 76.675c-10.152-13.3-10.101-31.312.834-42.247 10.934-10.934 29.001-11.04 42.372-.96l11.845-11.843Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "m87.082 21.625 66.146 66.146-66.146 66.147-10.514-10.514c5.635-13.017 3.458-28.261-6.731-38.388C59.698 94.939 44.5 92.786 31.503 98.34L20.936 87.77 32.03 76.675c-10.152-13.3-10.101-31.312.834-42.247 10.934-10.934 29.001-11.04 42.372-.96l11.845-11.843Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5524_7477)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#62B953",
    d: "M114.441 95.521c-4.33 0-7.578-.95-9.743-2.85-2.14-1.926-3.21-4.956-3.21-9.09 0-2.388.441-4.468 1.322-6.24.881-1.796 2.278-3.196 4.192-4.197 1.913-1.002 4.393-1.502 7.439-1.502 2.392 0 4.381.128 5.967.385 1.586.257 2.656.513 3.209.77v1.156l.756 4.236c-.479-.334-1.196-.68-2.153-1.04-.931-.36-2.052-.654-3.361-.886-1.309-.256-2.756-.385-4.342-.385-1.738 0-3.147.283-4.23.848-1.057.564-1.838 1.425-2.341 2.58-.479 1.13-.718 2.555-.718 4.275 0 1.72.239 3.146.718 4.275.503 1.13 1.359 1.978 2.568 2.543 1.233.564 2.933.847 5.098.847s3.965-.308 5.4-.925c1.46-.616 2.454-1.206 2.983-1.771v1.155l.378 3.89c-.428.411-1.473.835-3.135 1.271-1.636.437-3.902.655-6.797.655Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5524_7477",
    width: 134.293,
    height: 136.293,
    x: 20.935,
    y: 21.625,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7477"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5524_7477",
    width: 23.884,
    height: 24.879,
    x: 101.488,
    y: 71.642,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7477"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCInactive);
export default __webpack_public_path__ + "static/media/c_inactive.5660a3fd10b36f424da2e6ab5e37d7a2.svg";
export { ForwardRef as ReactComponent };